export default {
  removeParticipant: 'Remove Participant',
  confirmStr1: 'Are you sure you want to remove',
  confirmStr2: 'from this call?',
  remove: 'Remove',
  cancel: 'Cancel',
  participants: 'Participants',
  participant: 'Participant',
  conferenceCall: 'Conference Call',
  unknownNumber: 'Anonymous',
} as const;
